import React from "react";

// Importing the Row component for rendering individual table rows
import Tr from "./Tr";

export default function Table({
  data, // Array of data to be displayed in the table
  onEdit, // Function to handle editing a row
  onDelete, // Function to handle deleting a row
  isAllowedToEditOrDelete, // Boolean to determine if editing or deleting is allowed
}) {
  return (
    <div className="form-container">
      <table className="table">
        <thead>
          <tr>
            <th className="col-numeric-date"><span className="extra_space_2">Layer name</span></th>
            <th className="col-numeric-date"><span className="extra_space_2">Choice</span></th>
            <th className="col-numeric-date">Order</th>
            <th className="col-options">Options</th>
          </tr>
        </thead>

        <tbody>
          {data.length === 0 ? (
            // Display a message if no data is found
            <tr>
              <td colSpan={4}>No data found....</td>
            </tr>
          ) : (
            // Map through the data array and create a row for each entry
            data.map((d, index) => (
              <Tr
                key={index} // Unique key for each row
                id={d.layer_choice_id} // ID for the layer choice
                layer_url={d.layer_url} // URL for the layer
                order={d.order} // Order of the layer
                layer_name={d.layer_name} // Name of the layer
                layer_preview_url={d.layer_preview_url} // Preview URL of the layer
                layer_preview_url_preview={d.layer_preview_url_preview}
                onEdit={onEdit} // Function passed down for editing a row
                onDelete={onDelete} // Function passed down for deleting a row
                isAllowedToEditOrDelete={isAllowedToEditOrDelete} // Flag to determine edit/delete permissions
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
